import React from 'react';

// components
import Asset from './Asset';

export default function SingleMedia(props) {
    const { data } = props;
    const caption = data.singleAsset[0]?.richTextSimple ? (
        <div
            className="full constrain-width mx-auto center-text"
            dangerouslySetInnerHTML={{ __html: data.singleAsset[0].richTextSimple }}
        />
    ) : null;

    const asset = data.assetLink ? (
        <a href={data.assetLink}>
            <Asset data={data.singleAsset[0]?.imageFile} title={data.singleAsset[0]?.title} link />
        </a>
    ) : (
        <Asset data={data.singleAsset[0]?.imageFile} title={data.singleAsset[0]?.title} />
    );

    return (
        <div className="relative">
            <div className="flex justify-center">{asset}</div>
            {caption}
        </div>
    );
}
